var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vpc-overview"},[_c('Table',{attrs:{"bordered":"","rowKey":"id","loading":_vm.loading,"pagination":false,"columns":_vm.columns,"data-source":_vm.formatedVpcs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }